import { Authority } from "@skinsoft/types";
import { SEARCH_TYPES } from "@skinsoft/const";

import { AuthorityDataStore } from "@skinsoft/entity";
import { CACHE_KEYS, AuthorityOfflineDataFetcher } from "@skinsoft/offline";
import { EntitySyncDownHandler } from "../../entity-sync-down-handler";

declare const config
const SEARCH_PAGE_SIZE = config.syncDownPageSize.authority ?? config.syncDownPageSize.default

export class AuthoritySyncDownHandler extends EntitySyncDownHandler<Authority, Authority, Authority> {
    private static instance: AuthoritySyncDownHandler = null as any

    public static getInstance() {
        if (!AuthoritySyncDownHandler.instance) {
            AuthoritySyncDownHandler.instance = new AuthoritySyncDownHandler()
        }

        return AuthoritySyncDownHandler.instance
    }

    public static install(Vue) {
        AuthoritySyncDownHandler.getInstance()
    }

    constructor() {
        super(
            [SEARCH_TYPES.authority],
            AuthorityDataStore.getInstance(),
            new AuthorityOfflineDataFetcher(),
            CACHE_KEYS.Authority,
            SEARCH_PAGE_SIZE
        )
    }
}